import ApiSlackNew from "../../../../../core/gd/api/integrations/slack-new";

export default function slackSettings_disconnect() {

    gd.layout.loading.showAppBusy()


    const request = ApiSlackNew.disconnect()
    request.done(data=>{
        gd.layout.loading.hide()
        gd.goTo('settings/integrations');
    });


}
